import { useState } from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function LoginPage() {
  const { admin, login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  if (admin) return <Navigate to="/admin/dashboard" replace />;

  const handle = e => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(form.email, form.password);
      navigate('/admin/dashboard');
    } catch {
      setError('Invalid email or password.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-vh-100 d-flex align-items-center justify-content-center" style={{ background: '#f4f6fb' }}>
      <div className="card shadow-sm" style={{ width: '100%', maxWidth: '420px' }}>
        <div className="card-body p-5">
          <div className="text-center mb-4">
            <h4 className="mt-3 fw-bold">MNCW Admin Panel</h4>
            <p className="text-muted small">Sign in to manage website content</p>
          </div>
          {error && <div className="alert alert-danger py-2">{error}</div>}
          <form onSubmit={submit}>
            <div className="mb-3">
              <label className="form-label text-muted small">Email Address</label>
              <input name="email" type="email" value={form.email} onChange={handle} required className="form-control" placeholder="example@domain.com" autoComplete="email" />
            </div>
            <div className="mb-4">
              <label className="form-label text-muted small">Password</label>
              <input name="password" type="password" value={form.password} onChange={handle} required className="form-control" placeholder="" autoComplete="current-password" />
            </div>
            <button type="submit" disabled={loading} className="btn btn-primary w-100 py-2 rounded-pill">
              {loading ? <span className="spinner-border spinner-border-sm me-2"></span> : null}
              Sign In
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
